<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import * as types from '../store/mutation-types'

  export default {
    name: 'HospitalSelector',

    props: ['isCompleted'],

    computed: {
      ...mapGetters(['getHospitals', 'getSelectedHospital', 'getLabel']),
    },

    methods: {
      ...mapActions(['setHospitalInfo', 'completeStep', 'resetStepsTo']),
      ...mapMutations([types.SET_HOSPITAL]),

      setHospital: function (hospitalObj) {
        let ctx = this;

        this.setHospitalInfo({vm: this, hospitalId: hospitalObj.value}).then(response => {
          this.$analytics.pushEvent("struttura:step-completed");
          ctx.completeStep(0);
        })
      },

      reset: function () {
        this.resetStepsTo(0);
        this[types.SET_HOSPITAL](null);
        this.selectedHospital = null;
        this.eventHub.$emit("resetAll");
      }
    },

    data: function () {
      return {
        selectedHospital: null
      }
    },

  }
</script>

<template>
  <div class="hospital-selector wrap-step" :class="{checked : isCompleted}" v-if="$config.enableHospitalsChoice">
    <h4>
      <Msg id="ospedali.form.hospitalselector.title"/>
    </h4>

    <div v-if="!isCompleted">
      <v-select v-model="selectedHospital" @input="setHospital(selectedHospital)"
                v-validate="'required'" :options="getHospitals" label="label"
                :placeholder="getLabel('ospedali.form.hospitalselector.select.default')">
        <span slot="no-options">
          {{getLabel('ospedali.form.empty.select')}}
        </span>
      </v-select>
    </div>
    <div v-else="">
      <span>{{getSelectedHospital.title}}</span>
      <button @click="reset()" class="button-text">{{getLabel("ospedali.form.button.modify")}}</button>
    </div>
  </div>
</template>